module.exports = __webpack_public_path__ + "img/c5201811.19dbdc85.jpg";